import axios from 'axios'
import { ConsignmentDetailRequest, ConsignmentDetailResponse } from '../../../../api/models'

const baseUrl = process.env.REACT_APP_API_URL

export async function createConsignmentDetailV2(request: ConsignmentDetailRequest) {
  const { data } = await axios.post<ConsignmentDetailResponse>(`${baseUrl}/v2/consignment-detail`, request)

  return data
}

export async function createConsignmentDetailDraftV2(request: ConsignmentDetailRequest) {
  const { data } = await axios.post<ConsignmentDetailResponse>(`${baseUrl}/v2/consignment-detail/draft`, request)

  return data
}
